import { toDate } from 'date-fns-tz';

export function parseLocalDateTime(
  date: string | null | undefined,
  time: string | null | undefined,
  timeZone: string | null | undefined
): Date | null {
  if (!date || !time) return null;
  return toDate(`${date} ${time}`, { timeZone: timeZone ?? 'UTC' });
}
